import { useFlag } from '@platform/flags';
import type { DashboardProps } from '../features/dashboard/dashboard-props.ts';
import { FixedDashboard } from '../features/dashboard/FixedDashboard.tsx';
import { PersonalizedDashboard } from '../features/dashboard/PersonalizedDashboard.tsx';

export type { ChosenDays } from '../features/dashboard/widgets/DashboardFilters.tsx';

export type DashboardPageProps = DashboardProps;

export const DashboardPage = (props: DashboardPageProps) =>
  useFlag('admin.dashboard-personalize') ? (
    <PersonalizedDashboard {...props} />
  ) : (
    <FixedDashboard {...props} />
  );
